import {
  AdminCountSupportReservationsFilter,
  SupportReservationsCountResult,
} from '../../graphql/API';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const supportCountReservationsForReviewApi = async (
  filter: AdminCountSupportReservationsFilter,
): Promise<SupportReservationsCountResult[]> => {
  const result = await executeGql<SupportReservationsCountResult[]>(
    supportCountReservationsForReviewQuery,
    {
      filter,
    },
  );
  return processGqlResult<SupportReservationsCountResult[]>(
    'supportCountReservationsForReview.items',
    result,
  );
};

export const supportCountReservationsForReviewQuery = /* GraphQL */ `
  query SupportCountReservationsForReview($filter: AdminCountSupportReservationsFilter) {
    supportCountReservationsForReview(filter: $filter) {
      items {
        reviewStaff
        count
      }
    }
  }
`;
